import { useCallback, useRef } from 'react';

/**
 * Returns a callback that transforms a scroll event handler to an offset
 * change handler. Supports an optional debounce as well.
 * @param offsetSize
 * @param onChange
 * @param debounceMs
 */
export function useOnScrollOffsetChangeCallback(offsetSize, onChange) {
  var debounceMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var debounceTimeout = useRef();
  var previousOffsetRef = useRef(0);
  return useCallback(event => {
    // clear previous debounce timer
    window.clearTimeout(debounceTimeout.current);
    debounceTimeout.current = window.setTimeout(() => {
      var offset = Math.floor(event.target.scrollTop / offsetSize);
      if (previousOffsetRef.current !== offset) {
        previousOffsetRef.current = offset;
        onChange(offset);
      }
    }, debounceMs);
  }, [debounceMs, offsetSize, onChange]);
}
export default useOnScrollOffsetChangeCallback;
//# sourceMappingURL=useOnScrollOffsetChangeCallback.js.map